/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
"use client";

import React from "react";
import style from "../index.module.scss";
import withHeaderFooter from "@/app/csr-src/hocs/with-header-footer";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";
import { SvgPath } from "../assets/index";
import JDILogin from "@/common-components-src/js/newlogin/index.newlogin";
import { sendPv, sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25427"

const SuccessDom: React.FC = withHeaderFooter(() => {
  const handleContinue = () => {
    sendClickTrack.NewPasswordSuc_Continue();
    JDILogin.getInstance().openLoginDialog(() => {}, {
      isForgotPassword: true,
    });
  };

  React.useEffect(()=> {
    sendPv.NewPasswordSuc()
  }, [])

  return (
    <div className={style.successBox}>
      <Helmet>
        <title>Password Changed Successfully | Joybuy</title>
        <meta
          name="description"
          content="Your password has been successfully updated. Shop securely at Joybuy.com and enjoy fast shipping and a delivery guarantee on all your orders."
        />
      </Helmet>
      <div className={style.successTitle}>
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d={SvgPath.d5} fill="#2FBC44" />
        </svg>
        <span>Password changed successfully</span>
      </div>
      <Button
        variant="contained"
        onClick={handleContinue}
        exptag={"exp|" + EXPOSURE_RECORD.NewPasswordSuc_ContinueExpo}
        data-exptag-config='{"useClick": false, "stay_duration": 0.6, "repeated":false, "area_rate": 0.01}'
        sx={{
          width: "450px",
          height: "48px",
          fontSize: "20px",
          backgroundColor: "#00000000", // 自定义背景颜色
          color: "#1a1a1a", // 自定义文字颜色
          textTransform: "none",
          boxShadow: "none",
          border: "1px solid #C2C4CC", // 自定义边框颜色
          "&:hover": {
            backgroundColor: "#eee", // 悬停时的背景颜色
          },
        }}
      >
        Continue
      </Button>
    </div>
  );
});

export default SuccessDom;
